import axios from "axios"
import * as actions from "../actions/annualReturnEmployee"

export function getEmployeesForAnnualReturn(lobbyistId, annualReturn) {
  return dispatch => {
    let url = `/api/annual-return-employee/${lobbyistId}/${annualReturn.AnnualReturnId}?startDate=${annualReturn.StartDate}&endDate=${annualReturn.EndDate}`
    return axios.get(process.env.REACT_APP_API_HOST + url)
      .then((response) => {
        let annualReturnEmployees = response.data ? response.data.$values : []
        dispatch(actions.getEmployeesForAnnualReturn(annualReturnEmployees))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actionCreators/annualReturnEmployee.js